import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	list: [],
	accountnumbersFetched: false,
};

const accountNumbersSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setAccountNumbersData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingAccountNumbers: (state, action) => {
			state.loading = action.payload;
		},
		setAllAccountNumbersList: (state, action) => {
			const { data } = action.payload;
			state.list = data || [];
			state.accountnumbersFetched = true;
		},
	},
});

export const { setAccountNumbersData, setLoadingAccountNumbers, setAllAccountNumbersList } =
	accountNumbersSlice.actions;
export default accountNumbersSlice.reducer;
